export default __webpack_public_path__ + "images/BTF.27b6cba.png";